/* Zlippers Badeschlappen-Konfigurator (Vorlage "Saya", Größe 41-42)
 * Ebenen pro Schuh (unten -> oben): Riemenfarbe, Kundenmotive (Bild/Text),
 * Cyan-Rand (optional), Gelber Rand (optional), Hilfslinie Prägefläche.
 * Mit Prägung werden Motive auf die Magenta-Fläche begrenzt.
 * Pad Print: eigene Bereiche "Sohle rechts/links" auf der Fersenseite des Fußbetts.
 */
(function () {
  'use strict';

  var ZONES = {
    right: {
      outer: 'M110.04,132.57c7.09,19.63,42.17,113.42,49.13,131.05,6.97,17.63,18.97,17.03,28.09,17.8,9.12.77,29.74,2.68,55.98,3.6,26.24.91,44.87,1.4,99.1,2.29,67.86,1.12,155.52-4.6,181.63-6.74,26.11-2.15,37.09-2.22,50.34-.86,13.26,1.37,24.61,4.91,35.2,3.52s16.18-7.03,19.79-15.25c3.62-8.23,10.03-25.57,15.46-42.17,5.42-16.58,47.86-136.8,51.97-149.14,5.87-17.58,3.16-25-15.8-24.2-11.5.48-78.86,3.48-100.73,4.94-21.88,1.46-96.88,12.34-159.74,16.22-62.87,3.89-112.97-2.45-136.58-5.62s-62.47-8.86-94.84-10.42c-32.36-1.55-65.35-5.35-75.84-6.37-10.5-1.02-18-.04-21.38,2.46-3.37,2.5-3.76,9.98-1.78,17.5,1.99,7.5,12.92,41.76,20.02,61.39Z',
      cyan: 'M123.37,127.76c7.07,19.57,42.04,113.08,48.98,130.66,3.05,7.7,7.61,8.17,16.09,8.88,9.01.76,29.38,2.65,55.28,3.55,26.18.92,44.75,1.4,98.84,2.29,67.33,1.12,154.31-4.57,180.23-6.7,27.47-2.27,39.01-2.26,52.96-.83,6.86.7,13.24,1.96,19.27,2.87,5.54.84,9.4,1.1,12.62.68,4.7-.62,6.61-2.24,8.68-6.91,3.5-7.98,9.68-24.79,14.94-40.86,5.21-15.9,44.39-126.95,51.28-147.08,2.17-6.31,1.28-7.8-5.6-7.5-19,.83-76.04,3.42-95.82,4.74-21.88,1.46-96.91,12.32-159.8,16.22-64.14,3.96-115.25-2.48-139.34-5.71-23.32-3.13-61.68-8.77-93.64-10.31-32.65-1.57-65.95-5.4-76.55-6.43l-.67-.06c-6.35-.59-7.92.74-5.95,7.27,3.64,12.1,12.29,38.86,18.2,55.22Z',
      magenta: 'M134.02,123.91c6.82,18.85,39.58,106.48,48.06,128.26.61,1.6,2.98,3.4,4.68,3.59.89.08,1.8.18,2.63.24,8.92.76,29.08,2.63,54.74,3.53,26.11.91,44.64,1.39,98.62,2.28,66.92,1.1,153.36-4.55,179.12-6.66,28.55-2.35,40.55-2.29,55.03-.8,7.06.72,13.62,1.99,19.82,2.94,2.39.36,4.15.56,5.48.66,2.16.17,4.9-1.54,5.7-3.54,3.37-8.41,8.03-22.62,12.58-36.53,4.38-13.38,32.82-94.13,45.85-131.45,2.53-7.25.12-7.79-5.62-7.54-24.95,1.13-63.37,2.94-78.85,3.97-21.89,1.46-96.95,12.34-159.86,16.24-65.15,4.03-117.07-2.51-141.55-5.8-23.08-3.08-61.03-8.69-92.66-10.21-22.4-1.08-45.12-3.22-60.67-4.79-7.19-.72-8.1.76-5.98,7.38,4.01,12.48,9.04,27.58,12.88,38.23Z'
    },
    left: {
      outer: 'M697.17,338.68c-3.38-2.48-10.88-3.48-21.38-2.46-10.49,1.02-43.48,4.82-75.84,6.38s-71.22,7.25-94.84,10.42c-23.62,3.16-73.72,9.49-136.58,5.6-62.87-3.89-137.87-14.75-159.74-16.21-21.86-1.46-89.23-4.48-100.73-4.96-18.96-.79-21.68,6.64-15.8,24.2,4.12,12.35,46.55,132.56,51.97,149.15s11.82,33.93,15.44,42.16c3.62,8.23,9.2,13.86,19.8,15.25,10.58,1.4,21.94-2.15,35.2-3.5,13.25-1.36,24.23-1.3,50.34.85,26.11,2.15,113.77,7.87,181.63,6.76,54.23-.9,72.85-1.38,99.1-2.3,26.24-.91,46.86-2.83,55.98-3.59,9.12-.77,21.12-.17,28.08-17.8,6.97-17.64,42.05-111.42,49.14-131.06,7.09-19.63,18.02-53.89,20.02-61.39,1.98-7.5,1.6-15-1.78-17.5Z',
      cyan: 'M677.85,350.27l-.68.06c-10.58,1.02-43.88,4.86-76.54,6.43-31.96,1.54-70.32,7.18-93.64,10.3-24.1,3.23-75.2,9.68-139.34,5.71-62.89-3.89-137.93-14.76-159.8-16.22-19.78-1.32-76.82-3.9-95.82-4.73-6.89-.3-7.78,1.18-5.6,7.5,6.89,20.12,46.07,131.18,51.26,147.08,5.27,16.07,11.45,32.88,14.95,40.85,2.06,4.67,3.97,6.3,8.68,6.91,3.23.43,7.08.16,12.62-.68,6.02-.91,12.41-2.16,19.27-2.87,13.94-1.43,25.49-1.43,52.96.83,25.91,2.14,112.9,7.81,180.23,6.71,54.1-.9,72.66-1.38,98.83-2.29,25.92-.91,46.28-2.8,55.3-3.55,8.48-.72,13.04-1.18,16.09-8.88,6.95-17.58,41.92-111.1,48.98-130.67,5.92-16.37,14.57-43.12,18.2-55.21,1.97-6.54.4-7.86-5.95-7.27Z',
      magenta: 'M661.84,363.3c-15.55,1.57-38.27,3.71-60.67,4.79-31.63,1.51-69.6,7.12-92.68,10.21-24.47,3.28-76.39,9.82-141.54,5.78-62.92-3.89-137.98-14.76-159.86-16.22-15.48-1.03-53.9-2.84-78.85-3.97-5.74-.26-8.15.29-5.62,7.52,13.03,37.32,41.47,118.08,45.84,131.46,4.56,13.9,9.22,28.1,12.59,36.52.8,2.02,3.54,3.71,5.7,3.55,1.33-.11,3.1-.31,5.48-.67,6.2-.94,12.77-2.22,19.82-2.94,14.48-1.48,26.48-1.54,55.03.8,25.75,2.12,112.2,7.78,179.12,6.67,53.98-.89,72.5-1.37,98.62-2.28,25.67-.9,45.83-2.78,54.74-3.53.83-.07,1.74-.16,2.63-.25,1.7-.18,4.06-1.98,4.68-3.58,8.48-21.78,41.24-109.4,48.05-128.27,3.85-10.64,8.87-25.74,12.89-38.23,2.12-6.61,1.21-8.1-5.98-7.37Z'
    }
  };
  // Pad Print: Fersenbereich in pt, 1 pt = 0,353 mm. Druckfläche laut Inhaber: 4 cm quer, 7,5 cm längs der Sohle.
  var PAD_ZONE = {
    outer: 'M0,260 L0,115 C0,50 50,0 115,0 C180,0 230,50 230,115 L230,260 Z',
    magenta: 'M58.3,25 L171.7,25 L171.7,237.6 L58.3,237.6 Z'
  };
  ZONES.padRight = PAD_ZONE;
  ZONES.padLeft = PAD_ZONE;
  var OTHER = { right: 'left', left: 'right', padRight: 'padLeft', padLeft: 'padRight' };
  function isPad(side) { return side === 'padRight' || side === 'padLeft'; }
  function isDark(hex) {
    var n = parseInt(String(hex).slice(1), 16);
    return ((n >> 16 & 255) * 0.299 + (n >> 8 & 255) * 0.587 + (n & 255) * 0.114) < 128;
  }

  var COLORS = [
    ['#ffffff', 'Weiß'], ['#1c1c1c', 'Schwarz'], ['#3f5caa', 'Zlippers-Blau'], ['#1f2f5c', 'Navy'],
    ['#6fa8dc', 'Hellblau'], ['#d12b23', 'Rot'], ['#f28c28', 'Orange'], ['#f7d038', 'Gelb'],
    ['#2e8b57', 'Grün'], ['#8e44ad', 'Lila'], ['#e88fb4', 'Rosa'], ['#9e9e9e', 'Grau']
  ];
  var SOLE_COLORS = [
    ['#ffffff', 'Weiß'], ['#1c1c1c', 'Schwarz'], ['#2e8b57', 'Grün'], ['#d12b23', 'Rot'],
    ['#1f2f5c', 'Navy'], ['#2350c8', 'Royalblau']
  ];
  var FONTS = ['Montserrat', 'Bebas Neue', 'Oswald', 'Anton', 'Permanent Marker', 'Pacifico', 'Lobster', 'Roboto Slab'];

  var I18N = {
    de: {
      right: 'Rechter Schuh', left: 'Linker Schuh', upload: 'Bild hochladen', addText: 'Text hinzufügen',
      textPlaceholder: 'Dein Text', strap: 'Riemenfarbe', ringCyan: 'Innerer Rand', ringYellow: 'Äußerer Rand',
      none: 'Keine (Bild sichtbar)', sole: 'Sohlenfarbe (beide Schuhe)', emboss: 'Geprägt (erhaben)',
      embossHint: 'Prägung ist nur in der gestrichelten Fläche möglich. Motive werden dort abgeschnitten.',
      size: 'Größe', scale: 'Größe des Motivs', rotate: 'Drehen', crop: 'Zuschneiden', cropL: 'Links', cropR: 'Rechts',
      cropT: 'Oben', cropB: 'Unten', front: 'Nach vorne', back: 'Nach hinten', del: 'Löschen', center: 'Zentrieren',
      flip: 'Spiegeln', copy: 'Design auf anderen Schuh kopieren', font: 'Schrift', textColor: 'Textfarbe',
      selectHint: 'Klicke ein Motiv an, um es zu bearbeiten. Ziehen zum Verschieben.', qty: 'Anzahl Paare',
      add: 'In den Warenkorb', adding: 'Wird hochgeladen …', empty: 'Bitte gestalte mindestens einen Schuh.',
      tooBig: 'Das Bild ist größer als 20 MB.', error: 'Das hat nicht geklappt. Bitte versuche es erneut.',
      bulk: 'Ab 20 Paaren gilt automatisch der Mengenpreis.', layers: 'Motiv', text: 'Text', design: 'Gestaltung',
      colors: 'Farben', order: 'Bestellen', bold: 'Fett',
      padRight: 'Sohle rechts', padLeft: 'Sohle links', pad: 'Pad Print',
      padHint: 'Druck auf das Fußbett an der Ferse. Gestalte ihn unter „Sohle rechts“ und „Sohle links“, nur in der gestrichelten Fläche.',
      padEmpty: 'Bitte gestalte den Pad Print auf mindestens einer Sohle oder schalte ihn aus.',
      view3d: '3D-Ansicht', title3d: '3D-Ansicht deiner Badeschlappen', close: 'Schließen', zoomIn: 'Hineinzoomen', zoomOut: 'Herauszoomen',
      hint3d: 'Ziehen zum Drehen, Mausrad oder zwei Finger zum Zoomen. Vorschau, das Endprodukt kann leicht abweichen.',
      loading3d: '3D-Ansicht wird geladen …', failed3d: 'Die 3D-Ansicht konnte nicht geladen werden.'
    },
    en: {
      right: 'Right shoe', left: 'Left shoe', upload: 'Upload image', addText: 'Add text',
      textPlaceholder: 'Your text', strap: 'Strap colour', ringCyan: 'Inner border', ringYellow: 'Outer border',
      none: 'None (image visible)', sole: 'Sole colour (both shoes)', emboss: 'Embossed (raised)',
      embossHint: 'Embossing is only possible inside the dashed area. Designs are cut off there.',
      size: 'Size', scale: 'Design size', rotate: 'Rotate', crop: 'Crop', cropL: 'Left', cropR: 'Right',
      cropT: 'Top', cropB: 'Bottom', front: 'Bring forward', back: 'Send back', del: 'Delete', center: 'Center',
      flip: 'Mirror', copy: 'Copy design to other shoe', font: 'Font', textColor: 'Text colour',
      selectHint: 'Click a design to edit it. Drag to move.', qty: 'Number of pairs',
      add: 'Add to cart', adding: 'Uploading …', empty: 'Please design at least one shoe.',
      tooBig: 'The image is larger than 20 MB.', error: 'Something went wrong. Please try again.',
      bulk: 'From 20 pairs the bulk price applies automatically.', layers: 'Design', text: 'Text', design: 'Design',
      colors: 'Colours', order: 'Order', bold: 'Bold',
      padRight: 'Sole right', padLeft: 'Sole left', pad: 'Pad print',
      padHint: 'Print on the footbed at the heel. Design it under "Sole right" and "Sole left", only inside the dashed area.',
      padEmpty: 'Please design the pad print on at least one sole or switch it off.',
      view3d: '3D view', title3d: '3D view of your slides', close: 'Close', zoomIn: 'Zoom in', zoomOut: 'Zoom out',
      hint3d: 'Drag to rotate, scroll or use two fingers to zoom. Preview, the final product may differ slightly.',
      loading3d: 'Loading 3D view …', failed3d: 'The 3D view could not be loaded.'
    },
    tr: {
      right: 'Sağ terlik', left: 'Sol terlik', upload: 'Görsel yükle', addText: 'Metin ekle',
      textPlaceholder: 'Metnin', strap: 'Bant rengi', ringCyan: 'İç kenar', ringYellow: 'Dış kenar',
      none: 'Yok (görsel görünür)', sole: 'Taban rengi (iki terlik)', emboss: 'Kabartma',
      embossHint: 'Kabartma sadece kesikli alanda mümkündür. Tasarım orada kesilir.',
      size: 'Numara', scale: 'Tasarım boyutu', rotate: 'Döndür', crop: 'Kırp', cropL: 'Sol', cropR: 'Sağ',
      cropT: 'Üst', cropB: 'Alt', front: 'Öne getir', back: 'Arkaya gönder', del: 'Sil', center: 'Ortala',
      flip: 'Aynala', copy: 'Tasarımı diğer terliğe kopyala', font: 'Yazı tipi', textColor: 'Metin rengi',
      selectHint: 'Düzenlemek için bir tasarıma tıkla. Taşımak için sürükle.', qty: 'Çift sayısı',
      add: 'Sepete ekle', adding: 'Yükleniyor …', empty: 'Lütfen en az bir terliği tasarla.',
      tooBig: 'Görsel 20 MB\'tan büyük.', error: 'Bir sorun oluştu. Lütfen tekrar dene.',
      bulk: '20 çiftten itibaren toplu fiyat otomatik uygulanır.', layers: 'Tasarım', text: 'Metin', design: 'Tasarım',
      colors: 'Renkler', order: 'Sipariş', bold: 'Kalın',
      padRight: 'Sağ taban', padLeft: 'Sol taban', pad: 'Tampon baskı',
      padHint: 'Topuk tarafında taban içine baskı. „Sağ taban“ ve „Sol taban“ sekmelerinde, sadece kesikli alanda tasarla.',
      padEmpty: 'Lütfen en az bir tabana tampon baskı tasarla ya da seçeneği kapat.',
      view3d: '3D görünüm', title3d: 'Terliklerinin 3D görünümü', close: 'Kapat', zoomIn: 'Yakınlaştır', zoomOut: 'Uzaklaştır',
      hint3d: 'Döndürmek için sürükle, yakınlaştırmak için tekerleği veya iki parmağını kullan. Önizlemedir, ürün biraz farklı olabilir.',
      loading3d: '3D görünüm yükleniyor …', failed3d: '3D görünüm yüklenemedi.'
    }
  };

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'on') Object.keys(attrs.on).forEach(function (ev) { n.addEventListener(ev, attrs.on[ev]); });
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }

  function dataUrlToFile(dataUrl, name) {
    var parts = dataUrl.split(','), bin = atob(parts[1]), arr = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return new File([arr], name, { type: parts[0].split(':')[1].split(';')[0] });
  }

  function ZlippersKonfigurator(root) {
    this.root = root;
    var lang = (document.documentElement.lang || 'de').slice(0, 2);
    this.t = I18N[lang] || I18N.en;
    this.cfg = JSON.parse(root.querySelector('[data-zk-config]').textContent);
    this.side = 'right';
    this.sides = {
      right: { json: null, strap: '#ffffff', cyan: null, yellow: null },
      left: { json: null, strap: '#ffffff', cyan: null, yellow: null },
      padRight: { json: null },
      padLeft: { json: null }
    };
    this.padOn = false;
    this.sole = '#1c1c1c';
    this.emboss = false;
    this.originals = []; // { id, file }
    this.build();
    this.initCanvas();
    this.loadSide('right');
    this.updatePrice();
  }

  ZlippersKonfigurator.prototype.build = function () {
    var t = this.t, self = this;
    var canvasWrap = el('div', { class: 'zk-stage' }, [el('canvas', { id: 'zk-canvas-' + this.cfg.section })]);
    this.tabs = {};
    var tabs = el('div', { class: 'zk-tabs', role: 'tablist' }, ['right', 'left', 'padRight', 'padLeft'].map(function (s) {
      var b = el('button', { type: 'button', class: 'zk-tab', role: 'tab', text: t[s], on: { click: function () { self.switchSide(s); } } });
      if (isPad(s)) b.hidden = true;
      self.tabs[s] = b; return b;
    }));
    var hint = el('p', { class: 'zk-hint', text: t.selectHint });
    this.btn3d = el('button', { type: 'button', class: 'zk-btn zk-btn--3d', text: t.view3d, on: { click: function () { self.open3d(); } } });

    // Motive
    this.fileInput = el('input', { type: 'file', accept: 'image/png,image/jpeg,image/webp', class: 'zk-hidden', on: { change: function (e) { self.onUpload(e); } } });
    var uploadBtn = el('button', { type: 'button', class: 'zk-btn zk-btn--primary', text: t.upload, on: { click: function () { self.fileInput.click(); } } });
    var textBtn = el('button', { type: 'button', class: 'zk-btn', text: t.addText, on: { click: function () { self.addText(); } } });
    var copyBtn = el('button', { type: 'button', class: 'zk-btn zk-btn--ghost', text: t.copy, on: { click: function () { self.copyToOther(); } } });

    // Bearbeitung des gewählten Motivs
    this.objPanel = el('div', { class: 'zk-panel zk-objpanel', hidden: 'hidden' });
    this.scaleIn = this.range(1, 300, 100, function (v) { self.setScale(v); });
    this.rotateIn = this.range(-180, 180, 0, function (v) { self.setProp('angle', +v); });
    this.objPanel.appendChild(this.field(t.scale, this.scaleIn));
    this.objPanel.appendChild(this.field(t.rotate, this.rotateIn));
    this.cropBox = el('div', { class: 'zk-crop' }, [el('strong', { text: t.crop })]);
    this.cropIns = {};
    ['L', 'R', 'T', 'B'].forEach(function (k) {
      self.cropIns[k] = self.range(0, 90, 0, function () { self.applyCrop(); });
      self.cropBox.appendChild(self.field(t['crop' + k], self.cropIns[k]));
    });
    this.objPanel.appendChild(this.cropBox);
    this.textBox = el('div', { class: 'zk-textbox' });
    this.textIn = el('input', { type: 'text', class: 'zk-input', maxlength: '40', on: { input: function (e) { self.setProp('text', e.target.value); } } });
    this.fontIn = el('select', { class: 'zk-input', on: { change: function (e) { self.setFont(e.target.value); } } },
      FONTS.map(function (f) { return el('option', { value: f, text: f }); }));
    this.boldIn = el('input', { type: 'checkbox', on: { change: function (e) { self.setProp('fontWeight', e.target.checked ? 700 : 400); } } });
    this.textBox.appendChild(this.field(t.text, this.textIn));
    this.textBox.appendChild(this.field(t.font, this.fontIn));
    this.textBox.appendChild(el('label', { class: 'zk-check' }, [this.boldIn, el('span', { text: t.bold })]));
    this.textBox.appendChild(this.field(t.textColor, this.swatches(function (c) { self.setProp('fill', c); }, false)));
    this.objPanel.appendChild(this.textBox);
    this.objPanel.appendChild(el('div', { class: 'zk-row' }, [
      el('button', { type: 'button', class: 'zk-btn zk-btn--small', text: t.center, on: { click: function () { self.centerActive(); } } }),
      el('button', { type: 'button', class: 'zk-btn zk-btn--small', text: t.flip, on: { click: function () { self.flipActive(); } } }),
      el('button', { type: 'button', class: 'zk-btn zk-btn--small', text: t.front, on: { click: function () { self.order(1); } } }),
      el('button', { type: 'button', class: 'zk-btn zk-btn--small', text: t.back, on: { click: function () { self.order(-1); } } }),
      el('button', { type: 'button', class: 'zk-btn zk-btn--small zk-btn--danger', text: t.del, on: { click: function () { self.removeActive(); } } })
    ]));

    // Farben
    this.strapSw = this.swatches(function (c) { self.sides[self.side].strap = c; self.renderZones(); }, false);
    this.cyanSw = this.swatches(function (c) { self.sides[self.side].cyan = c; self.renderZones(); }, true);
    this.yellowSw = this.swatches(function (c) { self.sides[self.side].yellow = c; self.renderZones(); }, true);
    this.soleSw = this.swatches(function (c) { self.sole = c; self.updateSole(); if (isPad(self.side)) self.renderZones(); }, false, SOLE_COLORS);
    this.solePreview = el('div', { class: 'zk-sole' });
    this.strapFields = [this.field(t.strap, this.strapSw), this.field(t.ringCyan, this.cyanSw), this.field(t.ringYellow, this.yellowSw)];
    var colors = el('div', { class: 'zk-panel' }, [
      el('h3', { class: 'zk-h', text: t.colors }),
      this.strapFields[0], this.strapFields[1], this.strapFields[2],
      this.field(t.sole, el('div', { class: 'zk-row' }, [this.solePreview, this.soleSw]))
    ]);

    // Bestellung
    this.embossIn = el('input', { type: 'checkbox', on: { change: function (e) { self.setEmboss(e.target.checked); } } });
    this.embossHint = el('p', { class: 'zk-hint zk-warn', text: t.embossHint, hidden: 'hidden' });
    this.padIn = el('input', { type: 'checkbox', on: { change: function (e) { self.setPad(e.target.checked); } } });
    this.padLabel = el('span', { text: t.pad });
    this.padHint = el('p', { class: 'zk-hint zk-warn', text: t.padHint, hidden: 'hidden' });
    var hasPadVariants = this.cfg.variants.some(function (v) { return v.pad; });
    var padRow = hasPadVariants ? el('label', { class: 'zk-check' }, [this.padIn, this.padLabel]) : null;
    this.sizeIn = el('select', { class: 'zk-input', on: { change: function () { self.updatePrice(); } } },
      this.cfg.sizes.map(function (s) { return el('option', { value: s, text: s }); }));
    if (this.cfg.sizes.indexOf(this.cfg.defaultSize) > -1) this.sizeIn.value = this.cfg.defaultSize;
    this.qtyIn = el('input', { type: 'number', min: '1', value: '1', class: 'zk-input zk-qty', on: { input: function () { self.updatePrice(); } } });
    this.priceEl = el('div', { class: 'zk-price' });
    this.msgEl = el('p', { class: 'zk-msg', role: 'alert' });
    this.addBtn = el('button', { type: 'button', class: 'zk-btn zk-btn--primary zk-btn--wide', text: t.add, on: { click: function () { self.addToCart(); } } });
    var order = el('div', { class: 'zk-panel' }, [
      el('h3', { class: 'zk-h', text: t.order }),
      el('label', { class: 'zk-check' }, [this.embossIn, el('span', { text: t.emboss })]), this.embossHint,
      padRow, this.padHint,
      el('div', { class: 'zk-row' }, [this.field(t.size, this.sizeIn), this.field(t.qty, this.qtyIn)]),
      this.priceEl, el('p', { class: 'zk-hint', text: t.bulk }), this.addBtn, this.msgEl
    ]);

    var tools = el('div', { class: 'zk-panel' }, [
      el('h3', { class: 'zk-h', text: t.design }),
      el('div', { class: 'zk-row' }, [uploadBtn, textBtn]), this.fileInput, copyBtn
    ]);

    this.root.querySelector('[data-zk-app]').appendChild(el('div', { class: 'zk-grid' }, [
      el('div', { class: 'zk-left' }, [tabs, canvasWrap, this.btn3d, hint]),
      el('div', { class: 'zk-right' }, [tools, this.objPanel, colors, order])
    ]));
    this.stage = canvasWrap;
  };

  ZlippersKonfigurator.prototype.field = function (label, input) {
    return el('label', { class: 'zk-field' }, [el('span', { class: 'zk-label', text: label }), input]);
  };
  ZlippersKonfigurator.prototype.range = function (min, max, val, fn) {
    return el('input', { type: 'range', min: String(min), max: String(max), value: String(val), class: 'zk-range', on: { input: function (e) { fn(e.target.value); } } });
  };
  ZlippersKonfigurator.prototype.swatches = function (fn, allowNone, list) {
    var wrap = el('div', { class: 'zk-swatches' });
    var all = (allowNone ? [[null, this.t.none]] : []).concat(list || COLORS);
    all.forEach(function (c) {
      var b = el('button', { type: 'button', class: 'zk-swatch' + (c[0] ? '' : ' zk-swatch--none'), title: c[1], 'aria-label': c[1], 'data-color': c[0] || '' });
      if (c[0]) b.style.background = c[0];
      b.addEventListener('click', function () {
        wrap.querySelectorAll('.zk-swatch').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active'); fn(c[0]);
      });
      wrap.appendChild(b);
    });
    // Feste Liste (Sohle): nur diese Farben, keine freie Farbwahl
    if (!list) wrap.appendChild(el('input', { type: 'color', class: 'zk-swatch zk-swatch--custom', title: '+', on: { input: function (e) { fn(e.target.value); } } }));
    return wrap;
  };
  ZlippersKonfigurator.prototype.markSwatch = function (wrap, color) {
    wrap.querySelectorAll('.zk-swatch:not(.zk-swatch--custom)').forEach(function (x) {
      x.classList.toggle('is-active', (x.getAttribute('data-color') || null) === (color || null));
    });
  };

  ZlippersKonfigurator.prototype.initCanvas = function () {
    var self = this;
    this.canvas = new fabric.Canvas('zk-canvas-' + this.cfg.section, { preserveObjectStacking: true, selection: false });
    this.resize();
    window.addEventListener('resize', function () { self.resize(); self.fitView(); });
    this.canvas.on('selection:created', function () { self.syncPanel(); });
    this.canvas.on('selection:updated', function () { self.syncPanel(); });
    this.canvas.on('selection:cleared', function () { self.syncPanel(); });
    this.canvas.on('object:scaling', function () { self.syncPanel(); });
    this.canvas.on('object:rotating', function () { self.syncPanel(); });
  };
  ZlippersKonfigurator.prototype.resize = function () {
    var w = Math.min(this.stage.clientWidth || 640, 900);
    this.canvas.setWidth(w); this.canvas.setHeight(Math.round(w * (isPad(this.side) ? 0.7 : 0.46)));
  };
  ZlippersKonfigurator.prototype.fitView = function () {
    var b = this.bounds, pad = 12, c = this.canvas;
    var z = Math.min((c.getWidth() - pad * 2) / b.width, (c.getHeight() - pad * 2) / b.height);
    var ox = (c.getWidth() - b.width * z) / 2 - b.left * z, oy = (c.getHeight() - b.height * z) / 2 - b.top * z;
    c.setViewportTransform([z, 0, 0, z, ox, oy]);
  };

  ZlippersKonfigurator.prototype.zonePath = function (d, opts) {
    return new fabric.Path(d, Object.assign({ selectable: false, evented: false, objectCaching: false, zk: 'zone' }, opts || {}));
  };
  ZlippersKonfigurator.prototype.clipFor = function () {
    var z = ZONES[this.side];
    return this.zonePath(this.emboss || isPad(this.side) ? z.magenta : z.outer, { absolutePositioned: true });
  };

  ZlippersKonfigurator.prototype.loadSide = function (side, done) {
    var self = this, z = ZONES[side], c = this.canvas;
    this.side = side;
    Object.keys(this.tabs).forEach(function (s) { self.tabs[s].classList.toggle('is-active', s === side); self.tabs[s].setAttribute('aria-selected', s === side); });
    c.clear();
    this.resize();
    var probe = this.zonePath(z.outer);
    this.bounds = { left: probe.left, top: probe.top, width: probe.width, height: probe.height };
    this.fitView();
    var finish = function () {
      self.renderZones();
      self.syncColors();
      self.syncPanel();
      if (done) done();
    };
    var st = this.sides[side];
    if (st.json && st.json.length) {
      fabric.util.enlivenObjects(st.json, function (objs) {
        objs.forEach(function (o) { o.clipPath = self.clipFor(); self.decorate(o); c.add(o); });
        finish();
      });
    } else finish();
  };

  ZlippersKonfigurator.prototype.userObjects = function () {
    return this.canvas.getObjects().filter(function (o) { return o.zk === 'user'; });
  };
  ZlippersKonfigurator.prototype.saveSide = function () {
    this.sides[this.side].json = this.userObjects().map(function (o) {
      return o.toObject(['zk', 'zkId', 'zkCrop']);
    });
  };

  ZlippersKonfigurator.prototype.renderZones = function () {
    var c = this.canvas, z = ZONES[this.side], st = this.sides[this.side];
    c.getObjects().filter(function (o) { return o.zk === 'zone' || o.zk === 'guide'; }).forEach(function (o) { c.remove(o); });
    if (isPad(this.side)) {
      c.insertAt(this.zonePath(z.outer, { fill: this.sole, stroke: '#c9ced8', strokeWidth: 0.6 }), 0);
      c.add(this.zonePath(z.magenta, { fill: '', stroke: isDark(this.sole) ? '#ffffff' : '#3f5caa', strokeWidth: 1, strokeDashArray: [5, 4], zk: 'guide', excludeFromExport: true }));
      c.requestRenderAll();
      return;
    }
    var base = this.zonePath(z.outer, { fill: st.strap, stroke: '#c9ced8', strokeWidth: 0.6 });
    c.insertAt(base, 0);
    if (st.cyan) c.add(this.zonePath(z.cyan + ' ' + z.magenta, { fill: st.cyan, fillRule: 'evenodd' }));
    if (st.yellow) c.add(this.zonePath(z.outer + ' ' + z.cyan, { fill: st.yellow, fillRule: 'evenodd' }));
    var guide = this.zonePath(z.magenta, { fill: '', stroke: '#3f5caa', strokeWidth: 1, strokeDashArray: [5, 4], zk: 'guide', excludeFromExport: true, opacity: this.emboss ? 1 : 0.45 });
    c.add(guide);
    c.requestRenderAll();
  };

  ZlippersKonfigurator.prototype.decorate = function (o) {
    o.set({ zk: 'user', cornerColor: '#3f5caa', borderColor: '#3f5caa', cornerStyle: 'circle', transparentCorners: false, cornerSize: 12 });
    if (!o.zkId) o.zkId = 'm' + Date.now() + Math.round(Math.random() * 1e4);
  };
  ZlippersKonfigurator.prototype.placeNew = function (o) {
    var mag = this.zonePath(ZONES[this.side].magenta);
    var cx = mag.left + mag.width / 2, cy = mag.top + mag.height / 2;
    o.set({ originX: 'center', originY: 'center', left: cx, top: cy });
    // Pad Print: die Fläche ist hochkant, deshalb steht Text und Querformat standardmäßig gedreht
    if (isPad(this.side) && (o.type !== 'image' || o.width >= o.height)) o.set('angle', -90);
    this.decorate(o);
    o.clipPath = this.clipFor();
    var c = this.canvas, guideIdx = c.getObjects().findIndex(function (x) { return x.zk === 'zone' && x !== c.item(0); });
    if (guideIdx > 0) c.insertAt(o, guideIdx); else c.add(o);
    this.keepZonesOnTop();
    c.setActiveObject(o); c.requestRenderAll(); this.syncPanel();
  };
  ZlippersKonfigurator.prototype.keepZonesOnTop = function () {
    var c = this.canvas;
    c.getObjects().filter(function (o, i) { return (o.zk === 'zone' && i > 0) || o.zk === 'guide'; }).forEach(function (o) { c.bringToFront(o); });
  };

  ZlippersKonfigurator.prototype.onUpload = function (e) {
    var self = this, file = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!file) return;
    if (file.size > 20 * 1024 * 1024) { this.msg(this.t.tooBig); return; }
    var id = 'm' + Date.now();
    this.originals.push({ id: id, file: file });
    var reader = new FileReader();
    reader.onload = function () {
      // Vorschau intern verkleinern, Original geht separat an die Bestellung
      var img = new Image();
      img.onload = function () {
        var max = 1600, s = Math.min(1, max / Math.max(img.width, img.height));
        var cv = document.createElement('canvas'); cv.width = Math.round(img.width * s); cv.height = Math.round(img.height * s);
        cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
        fabric.Image.fromURL(cv.toDataURL('image/png'), function (fi) {
          var mag = self.zonePath(ZONES[self.side].magenta);
          var turned = isPad(self.side) && fi.width >= fi.height;
          var fit = (turned ? Math.min(mag.height / fi.width, mag.width / fi.height) : Math.min(mag.width / fi.width, mag.height / fi.height)) * 0.9;
          fi.set({ scaleX: fit, scaleY: fit, zkId: id });
          fi.zkCrop = { L: 0, R: 0, T: 0, B: 0, w: fi.width, h: fi.height };
          self.placeNew(fi);
        });
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  };

  ZlippersKonfigurator.prototype.addText = function () {
    var self = this, font = FONTS[0];
    var fill = isPad(this.side) && isDark(this.sole) ? '#ffffff' : '#1c1c1c';
    var tx = new fabric.IText(this.t.textPlaceholder, { fontFamily: font, fontSize: isPad(this.side) ? 24 : 40, fill: fill, fontWeight: 700 });
    this.loadFont(font).then(function () {
      if (isPad(self.side)) {
        // Gedreht in die Fläche einpassen: Textbreite läuft entlang der Sohle
        tx.initDimensions();
        var mag = self.zonePath(ZONES[self.side].magenta);
        tx.set('fontSize', tx.fontSize * Math.min(mag.height * 0.75 / tx.width, mag.width * 0.7 / tx.height));
      }
      self.placeNew(tx);
    });
  };
  ZlippersKonfigurator.prototype.loadFont = function (f) {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return document.fonts.load('700 40px "' + f + '"').catch(function () {});
  };

  ZlippersKonfigurator.prototype.active = function () {
    var o = this.canvas.getActiveObject(); return o && o.zk === 'user' ? o : null;
  };
  ZlippersKonfigurator.prototype.syncPanel = function () {
    var o = this.active();
    if (!o) { this.objPanel.hidden = true; return; }
    this.objPanel.hidden = false;
    this.baseScale = this.baseScale || {};
    if (!this.baseScale[o.zkId]) this.baseScale[o.zkId] = o.scaleX;
    this.scaleIn.value = Math.round(Math.abs(o.scaleX) / this.baseScale[o.zkId] * 100);
    this.rotateIn.value = Math.round(((o.angle + 180) % 360) - 180);
    var isImg = o.type === 'image', isText = o.type === 'i-text';
    this.cropBox.hidden = !isImg; this.textBox.hidden = !isText;
    if (isImg) { var k = o.zkCrop; this.cropIns.L.value = k.L; this.cropIns.R.value = k.R; this.cropIns.T.value = k.T; this.cropIns.B.value = k.B; }
    if (isText) { this.textIn.value = o.text; this.fontIn.value = o.fontFamily; this.boldIn.checked = +o.fontWeight >= 700; }
  };
  ZlippersKonfigurator.prototype.setScale = function (v) {
    var o = this.active(); if (!o) return;
    var s = this.baseScale[o.zkId] * v / 100;
    o.set({ scaleX: (o.flipX ? 1 : 1) * s, scaleY: s }); o.setCoords(); this.canvas.requestRenderAll();
  };
  ZlippersKonfigurator.prototype.setProp = function (k, v) {
    var o = this.active(); if (!o) return;
    o.set(k, v); o.setCoords(); this.canvas.requestRenderAll();
  };
  ZlippersKonfigurator.prototype.setFont = function (f) {
    var self = this; this.loadFont(f).then(function () { self.setProp('fontFamily', f); });
  };
  ZlippersKonfigurator.prototype.applyCrop = function () {
    var o = this.active(); if (!o || o.type !== 'image') return;
    var k = o.zkCrop, el0 = o.getElement();
    var W = el0.naturalWidth || el0.width, H = el0.naturalHeight || el0.height;
    k.L = +this.cropIns.L.value; k.R = +this.cropIns.R.value; k.T = +this.cropIns.T.value; k.B = +this.cropIns.B.value;
    if (k.L + k.R > 95) { k.R = 95 - k.L; this.cropIns.R.value = k.R; }
    if (k.T + k.B > 95) { k.B = 95 - k.T; this.cropIns.B.value = k.B; }
    o.set({ cropX: W * k.L / 100, cropY: H * k.T / 100, width: W * (1 - (k.L + k.R) / 100), height: H * (1 - (k.T + k.B) / 100) });
    o.setCoords(); this.canvas.requestRenderAll();
  };
  ZlippersKonfigurator.prototype.centerActive = function () {
    var o = this.active(); if (!o) return;
    var mag = this.zonePath(ZONES[this.side].magenta);
    o.setPositionByOrigin(new fabric.Point(mag.left + mag.width / 2, mag.top + mag.height / 2), 'center', 'center');
    o.setCoords(); this.canvas.requestRenderAll();
  };
  ZlippersKonfigurator.prototype.flipActive = function () { var o = this.active(); if (o) { o.set('flipX', !o.flipX); this.canvas.requestRenderAll(); } };
  ZlippersKonfigurator.prototype.order = function (dir) {
    var o = this.active(); if (!o) return;
    var users = this.userObjects(), i = users.indexOf(o), j = i + dir;
    if (j < 0 || j >= users.length) return;
    var c = this.canvas, target = c.getObjects().indexOf(users[j]);
    c.moveTo(o, target); this.keepZonesOnTop(); c.requestRenderAll();
  };
  ZlippersKonfigurator.prototype.removeActive = function () {
    var o = this.active(); if (!o) return;
    var id = o.zkId;
    this.canvas.remove(o); this.canvas.discardActiveObject(); this.canvas.requestRenderAll(); this.syncPanel();
    this.saveSide();
    var sides = this.sides;
    var used = Object.keys(sides).some(function (s) { return (sides[s].json || []).some(function (j) { return j.zkId === id; }); });
    if (!used) this.originals = this.originals.filter(function (x) { return x.id !== id; });
  };

  ZlippersKonfigurator.prototype.switchSide = function (side) {
    if (side === this.side) return;
    this.canvas.discardActiveObject();
    this.saveSide();
    this.loadSide(side);
  };
  ZlippersKonfigurator.prototype.copyToOther = function () {
    this.saveSide();
    var other = OTHER[this.side];
    var src = this.sides[this.side], dst = this.sides[other];
    // Motive relativ zur Magenta-Fläche übertragen
    var a = this.zonePath(ZONES[this.side].magenta), b = this.zonePath(ZONES[other].magenta);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    dst.json = JSON.parse(JSON.stringify(src.json)).map(function (j) {
      // linke/top in Ursprungs-Koordinaten verschieben
      j.left += dx; j.top += dy; delete j.clipPath; return j;
    });
    if (!isPad(this.side)) { dst.strap = src.strap; dst.cyan = src.cyan; dst.yellow = src.yellow; }
    this.switchSide(other);
  };

  ZlippersKonfigurator.prototype.setEmboss = function (on) {
    var self = this;
    this.emboss = on;
    this.embossHint.hidden = !on;
    this.userObjects().forEach(function (o) { o.clipPath = self.clipFor(); o.dirty = true; });
    this.renderZones();
    this.updatePrice();
  };
  ZlippersKonfigurator.prototype.setPad = function (on) {
    this.padOn = on;
    this.padHint.hidden = !on;
    this.tabs.padRight.hidden = !on; this.tabs.padLeft.hidden = !on;
    if (on) this.switchSide('padRight');
    else if (isPad(this.side)) this.switchSide('right');
    this.updatePrice();
  };
  ZlippersKonfigurator.prototype.syncColors = function () {
    var st = this.sides[this.side], pad = isPad(this.side);
    this.strapFields.forEach(function (f) { f.hidden = pad; });
    this.markSwatch(this.strapSw, st.strap); this.markSwatch(this.cyanSw, st.cyan); this.markSwatch(this.yellowSw, st.yellow);
    this.markSwatch(this.soleSw, this.sole); this.updateSole();
  };
  ZlippersKonfigurator.prototype.updateSole = function () { this.solePreview.style.background = this.sole; };

  ZlippersKonfigurator.prototype.variant = function () {
    var size = this.sizeIn.value, emb = this.emboss, pad = this.padOn;
    return this.cfg.variants.filter(function (v) { return v.size === size && v.emboss === emb && !!v.pad === pad; })[0];
  };
  ZlippersKonfigurator.prototype.updatePrice = function () {
    var v = this.variant(), q = Math.max(1, parseInt(this.qtyIn.value, 10) || 1);
    if (!v) { this.priceEl.textContent = ''; this.addBtn.disabled = true; return; }
    this.addBtn.disabled = !v.available;
    var unit = v.price;
    // Mengenpreis als Faktor, damit er in jeder Währung stimmt (Rabatt läuft über Shopify-Automatikrabatt)
    var b = this.cfg.bulk;
    if (q >= b.minQty) unit = Math.round(v.price * (this.padOn ? (this.emboss ? b.embossPad : b.plainPad) : (this.emboss ? b.emboss : b.plain)));
    var size = this.sizeIn.value, emb = this.emboss;
    var pair = this.cfg.variants.filter(function (x) { return x.size === size && x.emboss === emb; });
    var withPad = pair.filter(function (x) { return x.pad; })[0], noPad = pair.filter(function (x) { return !x.pad; })[0];
    if (withPad && noPad) this.padLabel.textContent = this.t.pad + ' (+' + this.money(withPad.price - noPad.price) + ')';
    this.priceEl.textContent = this.money(unit) + ' × ' + q + ' = ' + this.money(unit * q);
  };
  ZlippersKonfigurator.prototype.money = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: this.cfg.currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + this.cfg.currency; }
  };
  ZlippersKonfigurator.prototype.msg = function (s) { this.msgEl.textContent = s || ''; };

  // Druckdatei einer Seite rendern (ohne Hilfslinie, hohe Auflösung, nur Riemenbereich)
  ZlippersKonfigurator.prototype.exportSide = function (side, mult, motifsOnly) {
    var self = this;
    return new Promise(function (resolve) {
      var go = function () {
        var c = self.canvas, pad = isPad(side);
        // Pad Print: nur die Motive auf transparentem Grund, zugeschnitten auf die Druckfläche
        var hide = c.getObjects().filter(function (o) { return o.zk === 'guide' || ((pad || motifsOnly) && o.zk === 'zone'); });
        c.discardActiveObject();
        hide.forEach(function (o) { o.visible = false; });
        var vpt = c.viewportTransform.slice(), w = c.getWidth(), h = c.getHeight();
        var b = self.bounds, z = mult;
        if (pad) { var m = self.zonePath(ZONES[side].magenta); b = { left: m.left, top: m.top, width: m.width, height: m.height }; }
        c.setViewportTransform([z, 0, 0, z, -b.left * z, -b.top * z]);
        c.setWidth(Math.ceil(b.width * z)); c.setHeight(Math.ceil(b.height * z));
        c.renderAll();
        var url = c.toDataURL({ format: 'png' });
        c.setWidth(w); c.setHeight(h); c.setViewportTransform(vpt);
        hide.forEach(function (o) { o.visible = true; });
        c.renderAll();
        resolve(url);
      };
      if (self.side === side) go();
      else { self.saveSide(); self.loadSide(side, go); }
    });
  };

  // Alle Flächen nacheinander rendern. Sohlen nur, wenn Pad Print an ist und dort etwas liegt.
  ZlippersKonfigurator.prototype.exportAll = function (mult, withMotifs) {
    var self = this, files = {}, back = this.side;
    this.saveSide();
    var list = ['right', 'left'];
    if (this.padOn) ['padRight', 'padLeft'].forEach(function (s) { if ((self.sides[s].json || []).length) list.push(s); });
    return list.reduce(function (p, s) {
      return p.then(function () { return self.exportSide(s, mult); }).then(function (url) { files[s] = url; });
    }, Promise.resolve()).then(function () {
      // Für die plastische Prägung in der 3D-Ansicht: nur die Motive, ohne Riemenfarbe
      if (!withMotifs) return null;
      return self.exportSide('right', mult, true).then(function (url) {
        files.rightMotif = url; return self.exportSide('left', mult, true);
      }).then(function (url) { files.leftMotif = url; });
    }).then(function () {
      self.loadSide(back);
      return files;
    });
  };

  ZlippersKonfigurator.prototype.open3d = function () {
    var self = this, t = this.t, btn = this.btn3d;
    if (btn.disabled) return;
    btn.disabled = true; this.msg('');
    var files;
    this.exportAll(2.4, this.emboss).then(function (f) {
      files = f;
      if (window.Zlippers3D) return null;
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = self.cfg.viewer3dUrl; s.onload = resolve; s.onerror = reject;
        document.head.appendChild(s);
      });
    }).then(function () {
      var bead = function (s) { var st = self.sides[s]; return st.yellow || st.cyan || st.strap; };
      window.Zlippers3D.open({
        right: files.right, left: files.left, padRight: files.padRight, padLeft: files.padLeft,
        rightMotif: files.rightMotif, leftMotif: files.leftMotif, emboss: self.emboss,
        sole: self.sole,
        shoes: {
          right: { strap: self.sides.right.strap, bead: bead('right') },
          left: { strap: self.sides.left.strap, bead: bead('left') }
        },
        text: { title: t.title3d, close: t.close, zoomIn: t.zoomIn, zoomOut: t.zoomOut, hint: t.hint3d, loading: t.loading3d, failed: t.failed3d }
      });
      btn.disabled = false;
    }).catch(function () {
      self.msg(t.failed3d);
      btn.disabled = false;
    });
  };

  ZlippersKonfigurator.prototype.summary = function () {
    var self = this, out = {};
    (this.padOn ? ['right', 'left', 'padRight', 'padLeft'] : ['right', 'left']).forEach(function (s) {
      var st = self.sides[s];
      out[s] = {
        strap: st.strap, innerBorder: st.cyan, outerBorder: st.yellow,
        texts: (st.json || []).filter(function (j) { return j.type === 'i-text'; }).map(function (j) { return { text: j.text, font: j.fontFamily, color: j.fill }; }),
        images: (st.json || []).filter(function (j) { return j.type === 'image'; }).map(function (j) { return j.zkId; })
      };
    });
    return out;
  };

  ZlippersKonfigurator.prototype.addToCart = function () {
    var self = this, t = this.t;
    this.saveSide();
    var hasDesign = ['right', 'left'].some(function (s) {
      var st = self.sides[s]; return (st.json && st.json.length) || st.cyan || st.yellow || st.strap !== '#ffffff';
    });
    var padDesign = ['padRight', 'padLeft'].some(function (s) { return (self.sides[s].json || []).length; });
    if (this.padOn && !padDesign) { this.msg(t.padEmpty); return; }
    if (!hasDesign && !this.padOn) { this.msg(t.empty); return; }
    var v = this.variant(); if (!v) return;
    this.msg(''); this.addBtn.disabled = true; this.addBtn.textContent = t.adding;
    var printScale = 4.2; // ca. 300 dpi bei Originalgröße der Vorlage (pt)
    this.exportAll(printScale).then(function (files) {
      var sum = self.summary(), fd = new FormData();
      var name = function (c) { return c ? (COLORS.concat(SOLE_COLORS).filter(function (x) { return x[0] === c; })[0] || [c, c])[1] + ' ' + c : '–'; };
      fd.append('id', v.id);
      fd.append('quantity', Math.max(1, parseInt(self.qtyIn.value, 10) || 1));
      fd.append('properties[Design rechts]', dataUrlToFile(files.right, 'design-rechts.png'));
      fd.append('properties[Design links]', dataUrlToFile(files.left, 'design-links.png'));
      if (files.padRight) fd.append('properties[Pad Print rechts]', dataUrlToFile(files.padRight, 'pad-print-rechts.png'));
      if (files.padLeft) fd.append('properties[Pad Print links]', dataUrlToFile(files.padLeft, 'pad-print-links.png'));
      fd.append('properties[Riemen rechts]', name(sum.right.strap) + ' · Innen: ' + name(sum.right.innerBorder) + ' · Außen: ' + name(sum.right.outerBorder));
      fd.append('properties[Riemen links]', name(sum.left.strap) + ' · Innen: ' + name(sum.left.innerBorder) + ' · Außen: ' + name(sum.left.outerBorder));
      fd.append('properties[Sohle]', name(self.sole));
      var texts = sum.right.texts.map(function (x) { return 'R: ' + x.text + ' (' + x.font + ')'; })
        .concat(sum.left.texts.map(function (x) { return 'L: ' + x.text + ' (' + x.font + ')'; }));
      if (self.padOn) {
        texts = texts.concat(sum.padRight.texts.map(function (x) { return 'Sohle R: ' + x.text + ' (' + x.font + ')'; }))
          .concat(sum.padLeft.texts.map(function (x) { return 'Sohle L: ' + x.text + ' (' + x.font + ')'; }));
      }
      if (texts.length) fd.append('properties[Texte]', texts.join(' | '));
      // Ausgeschalteter Pad Print: Bilder nur auf der Sohle gehen nicht mit
      var usedImages = Object.keys(sum).reduce(function (all, s) { return all.concat(sum[s].images); }, []);
      self.originals.filter(function (o) { return usedImages.indexOf(o.id) > -1; }).forEach(function (o, i) {
        if (i < 4) fd.append('properties[_Originalbild ' + (i + 1) + ']', o.file, o.file.name);
      });
      fd.append('properties[_Konfiguration]', JSON.stringify({ template: 'saya-41-42', emboss: self.emboss, padPrint: self.padOn, sole: self.sole, sides: sum }));
      return fetch(self.cfg.cartAddUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || j.message || res.status); });
      window.location.href = self.cfg.cartUrl;
    }).catch(function (err) {
      self.msg(t.error + (err && err.message ? ' (' + err.message + ')' : ''));
      self.addBtn.disabled = false; self.addBtn.textContent = t.add;
    });
  };

  function boot() {
    document.querySelectorAll('[data-zk-root]').forEach(function (root) {
      if (root.zk) return;
      if (!window.fabric) { root.querySelector('[data-zk-app]').textContent = 'Editor konnte nicht geladen werden.'; return; }
      root.zk = new ZlippersKonfigurator(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.ZlippersKonfigurator = ZlippersKonfigurator;
})();